module.exports = __webpack_public_path__ + "Roboto-Italic.fd5970128586cba8e7ed.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Italic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Italic.woff
// module chunks = styles